import React, { Component } from "react";
import { Menu } from "antd";
import { connect } from 'react-redux';
import $ from '../../common/AjaxRequest';
import API_URL from '../../common/url';

const SubMenu = Menu.SubMenu;

class SideNav extends Component {
    constructor(props) {
        super(props);
        let current = 'degree';
        if (props.selectKey) {
            current = props.selectKey;
        }
        this.state = {
            current,
        };
    }

    handleClick = e => {
        this.setState({ current: e.key });
    }

    render () {
        const { current } = this.state;
        const { menuAuth = {} } = this.props;
        const { curRole } = sessionStorage;
        const { isInvAreaLeader, isInvPM } = menuAuth;
        const isCRC = curRole == 'CRC';
        const isCRCC = curRole == 'CRCC';
        const isPM = curRole == 'PM';
        const isCRCM = curRole == 'CRCM';
        const isBO = curRole == 'BO';
        const isBD = curRole == 'BD';
        const isTAL = curRole == 'TAL';
        const isBDO = curRole == 'BDO';
        const isBDM = curRole == 'BDM';
        const isPA = curRole == 'PA';
        const isCTA = curRole == 'CTA';
        const isVP = curRole == 'VP';
        const isFIN = curRole == 'FIN';
        const isBA = curRole == 'BA';
        const isBAL = curRole == 'BAL';
        const isPML = curRole == 'PML';
		const isCSA = curRole == 'CSA';
        const isCSAL = curRole == 'CSAL';
        const isHRRC = curRole == 'HRRC';
		const showContractModuleForCRC = isInvPM && (isCRC || isCRCC || isCRCM);
        const isDefaultAuth = (isBO || isBDO || isBDM || isPM || isBO || isCTA || isVP || isFIN || isBA || isBAL || isPML || isCSA || isCSAL || showContractModuleForCRC  || isCRCC || isCRCM);
        // CRC协议报表汇总可见角色
        const showCrcAgreeReport = (isVP || isBO || isPM || isPA || isCRCC || isCRCM || isPML || isCRC || isCSA || isCSAL);
		
        return (
            <aside className="sidebar">
                <Menu
                    onClick={this.handleClick}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[current]}
                    mode="inline"
                >
                    <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe64e;</i><span>合同管理</span></span>}>
                        {
                            (isDefaultAuth) &&
                            <Menu.Item key="record">
                                <a href="#/contractManagement/contractRecord">合同记录</a>
                            </Menu.Item>
                        }
                        {
                            isDefaultAuth && <Menu.Item key="requestRecord">
                                <a href="#/contractManagement/requestRecord">合同请款记录</a>
                            </Menu.Item>
                        }
                        {
                            (isBO || isCTA || isVP || isPML || isInvAreaLeader || isInvPM || isBAL || isBA || isFIN || isCSA || isCSAL  || isCRCC || isCRCM) && <Menu.Item key="coFollowFunds">
                            <a href="#/contractManagement/coFollowFunds">CO跟进和请款预计</a>
                            </Menu.Item>
                        }
                        {
                            (isDefaultAuth || isHRRC) &&
                            <Menu.Item key="returnedMoney">
                                <a href="#/projectContract/returnedMoney">发票和回款记录</a>
                            </Menu.Item>
                        }
                        {
                            (isVP || isFIN || isBO || isCSAL || isPML || isPM || isCSA || isInvAreaLeader || isInvPM ) &&
                            <Menu.Item key="ptReimburse">
                                <a href="#/contractManagement/ptReimburse">PT费用报销记录</a>
                            </Menu.Item>
                        }
                        {
                            isDefaultAuth && 
                            <Menu.Item key="identificationCode">
                                <a href="#/contractManagement/identificationCode">项目识别码</a>
                            </Menu.Item>
                        }
                        {
                            isDefaultAuth && 
                            <Menu.Item key="applyJdeCode">
                                <a href="#/contractManagement/applyJdeCode">JDE建号申请记录</a>
                            </Menu.Item>
                        }
                        {
                            isDefaultAuth && 
                            <Menu.Item key="contractInfoChange">
                                <a href="#/contractManagement/contractInfoChange">合同信息变更申请</a>
                            </Menu.Item>
                        }
                        {
                            isDefaultAuth && !( isBA || isBAL ) &&
                            <Menu.Item key="alterJdeCode">
                                <a href="#/contractManagement/alterJdeCode">JDE主项目号变更申请</a>
                            </Menu.Item>
                        }
                        {
                            isDefaultAuth && 
                            <Menu.Item key="terminationApply">
                                <a href="#/contractManagement/terminationApply">项目终止申请</a>
                            </Menu.Item>
                        }
                        {
                            isDefaultAuth && isFIN &&
                            <Menu.Item key="currencyExchangeRate">
                                <a href="#/contractManagement/currencyExchangeRate">币种汇率</a>
                            </Menu.Item>
                        }
                        {
                            isDefaultAuth &&
                            <Menu.Item key="responseCustomer">
                                <a href="#/contractManagement/responseCustomer">负责客户清单</a>
                            </Menu.Item>
                        }
                        {
                            (isBA || isBD || isBDO || isBAL || isBDM) &&
                            <Menu.Item key="crmContractRecord">
                                <a href="#/contractManagement/crmContractRecord">CRM合同记录</a>
                            </Menu.Item>
                        }
                        {
                            isFIN &&
                            <Menu.Item key="activityitem">
                                <a href="#/contractManagement/activityitem">活动项目代码表</a>
                            </Menu.Item>
                        }
                        {
                            showCrcAgreeReport &&
                            <Menu.Item key="crcAgreeReportSummary">
                                <a href="#/contractManagement/crcAgreeReportSummary">CRC协议报表汇总</a>
                            </Menu.Item>
                        }
                    </SubMenu>
                </Menu>
            </aside>
        );
    }
}

//export default SideNav;
const mapStateToProps = (state, props) => {
    return {
        menuAuth: state.menuState.menuAuth || {},
    }
};
// const mapDispatchToProps = (dispatch) => {
//     return {
//         saveParams: (params) => dispatch(saveParams(params)),
//     }
// };

export default connect(mapStateToProps, null)(SideNav);



// WEBPACK FOOTER //
// ./src/components/contractManagement/SideNav.js